module.exports = __WEBPACK_EXTERNAL_MODULE_react_intl_next__;